import { Component } from '@angular/core';

import { PopoverController } from '@ionic/angular';

@Component({
  template: `
    <ion-list>
      <ion-item button (click)="close('https://test-site.onlinebite.co.uk')">
        <ion-label>onlinebite test site</ion-label>
      </ion-item>
      <ion-item button (click)="close('https://ionicframework.com/docs/')">
        <ion-label>Documentation</ion-label>
      </ion-item>
      <ion-item button (click)="close('https://showcase.ionicframework.com')">
        <ion-label>Showcase</ion-label>
      </ion-item>
      <ion-item button (click)="close('https://github.com/ionic-team/ionic')">
        <ion-label>GitHub Repo</ion-label>
      </ion-item>
      <ion-item button (click)="support()">
        <ion-label>Support</ion-label>
      </ion-item>
    </ion-list>
  `
})
export class PopoverPage {
  constructor(public popoverCtrl: PopoverController) {}

  support() {
    // this.app.getRootNavs()[0].push('/support');
    this.popoverCtrl.dismiss();
  }

  close(url: string) {
    let options = '';
    options += 'location=no';
    options += ',hidenavigationbuttons=yes';
    options += ',navigationbuttoncolor=#ffffff';
    options += ',hideurlbar=yes';
    options += ',closebuttoncaption=Others';
    options += ',closebuttoncolor=#ffffff';


    window.open(url, '_blank', options);
    this.popoverCtrl.dismiss();
  }
}
